// @flow
import {
  SET_PAYMENT_METHODS_ORDER,
  SET_SELECTED_PAYMENT_METHOD,
  SET_SELECTED_PAYMENT_OPTION,
  SET_STORE_USER_CONFIRM_PAYMENT,
  RESET,
  SET_PREVIOUSLY_LOGGED_IN
} from './mutation-types'
import type { PaymentMethodsOrder } from '../../../types/payment-methods-order'
import type { PaymentState } from './index'
import PaymentMethod from '../../../types/payment-method'
import PaymentOption from '../../../types/payment-option'

export default {
  [SET_PAYMENT_METHODS_ORDER]: (state: PaymentState, paymentMethodsOrder: PaymentMethodsOrder) => {
    state.paymentMethodsOrder = paymentMethodsOrder
  },
  [SET_SELECTED_PAYMENT_METHOD]: (state: PaymentState, paymentMethod: ?PaymentMethod) => {
    state.selectedPaymentMethod = paymentMethod
  },
  [SET_SELECTED_PAYMENT_OPTION]: (state: PaymentState, paymentOption: ?PaymentOption) => {
    state.selectedPaymentOption = paymentOption
  },
  [SET_STORE_USER_CONFIRM_PAYMENT]: (state: PaymentState, confirmed: boolean) => {
    state.storeUserPaymentConfirmed = confirmed
  },
  [RESET]: (state: PaymentState) => {
    Object.assign(state, {
      paymentMethodsOrder: null,
      selectedPaymentMethod: null,
      selectedPaymentOption: null,
      storeUserPaymentConfirmed: false
    })
  },
  [SET_PREVIOUSLY_LOGGED_IN]: (state: PaymentState, previouslyLoggedIn: boolean) => {
    state.previouslyLoggedIn = previouslyLoggedIn
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/mutations.js